import { render } from "./PinnedMessages.vue?vue&type=template&id=822c9016&scoped=true&ts=true"
import script from "./PinnedMessages.vue?vue&type=script&lang=ts"
export * from "./PinnedMessages.vue?vue&type=script&lang=ts"

import "./PinnedMessages.vue?vue&type=style&index=0&id=822c9016&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-822c9016"]])

export default __exports__